// React
import { useNavigate } from "react-router-dom";
// Style
import "../../styles/menu/PaymentStyle.scss";
// Recoil
import { useRecoilValue, useResetRecoilState, useSetRecoilState } from "recoil";
import {
  cartState,
  isOrderState,
  isRobot,
  isTooltipView,
  orderState,
} from "../../atom/menu";
import { useEffect, useState } from "react";
import { OrderDataListType } from "../../assets/Type";

function PaymentSuccess() {
  // 결제 완료 화면

  const navigate = useNavigate();

  // Recoil State
  const orderData = useRecoilValue(orderState);
  const setRobotView = useSetRecoilState(isRobot);
  const resetCart = useResetRecoilState(cartState);
  const resetOrderState = useResetRecoilState(isOrderState);
  const turnOnTooltipView = useSetRecoilState(isTooltipView);
  const [currentOrderData, setCurrentOrderData] =
    useState<OrderDataListType | null>(null);
  useEffect(() => {
    if (orderData && orderData.orderData.length > 0) {
      setCurrentOrderData(orderData.orderData[0]);
    }
  }, []);
  return (
    <>
      {currentOrderData && (
        <div className='intro-wrap'>
          <img
            className='absolute-logo'
            src={"/assets/images/menu/logo.png"}
            alt='vd company logo'
            style={{ width: 158 }}
          />

          <div className='payment-success-wrap' style={{ height: "100%" }}>
            <div
              className='payment-success-wrap'
              style={{ gap: 40, marginTop: 40 }}
            >
              <img src={"/assets/images/menu/success.svg"} alt='success icon' />
              <div
                className='TO-title-2 text-color-gray'
                style={{ textAlign: "center" }}
              >
                결제가 완료되었습니다
                <br />
                {currentOrderData.payment?.payType === "card" ||
                currentOrderData.payment?.payType === "npay"
                  ? "카드를 제거해 주세요"
                  : ""}
              </div>
              <div className='flex col align-items-center' style={{ gap: 12 }}>
                <div className='pay-row'>
                  <div className='TO-button-2 text-color-gray-6'>
                    {currentOrderData.payment?.payType === "card"
                      ? "카드결제"
                      : currentOrderData.payment?.payType === "cash"
                      ? "현금결제"
                      : currentOrderData.payment?.payType === "kakao"
                      ? "카카오페이 결제"
                      : "카드분할결제 1"}
                  </div>
                  <div className='TO-button-2 text-color-gray-5'>
                    {currentOrderData.payment?.payType === "npay"
                      ? currentOrderData.payment?.nPay![0].amount.toLocaleString()
                      : currentOrderData.payment?.payAmount.toLocaleString()}
                    원
                  </div>
                </div>
                {currentOrderData.payment?.payType === "npay" && (
                  <div className='pay-row'>
                    <div className='TO-button-2 text-color-gray-6'>
                      카드분할결제 2
                      {currentOrderData.payment.nPay!.length > 2 && (
                        <span>
                          외 {currentOrderData.payment?.nPay!.length - 1} 건
                        </span>
                      )}
                    </div>
                    <div className='TO-button-2 text-color-gray-5'>
                      {(
                        currentOrderData.payment?.payAmount! -
                        currentOrderData.payment?.nPay![0].amount
                      ).toLocaleString()}
                      원
                    </div>
                  </div>
                )}
                <div className='pay-row'>
                  <div className='TO-button-2 text-color-gray-6'>
                    포인트 사용 금액
                  </div>
                  <div className='TO-button-2 text-color-gray-5'>
                    {currentOrderData.payment!.usePoint.toLocaleString()} P
                  </div>
                </div>
                <div className='pay-row'>
                  <div className='TO-button-2 text-color-gray-6'>
                    포인트 적립 금액
                  </div>
                  <div className='TO-button-2 text-color-gray-5'>
                    {Math.floor(
                      currentOrderData.payment!.rewardPoint
                    ).toLocaleString()}{" "}
                    P
                  </div>
                </div>
                <div className='pay-row'>
                  <div className='TO-button-2 text-color-gray-6'>
                    총 결제금액
                  </div>
                  <div className='TO-price-1 text-color-gray'>
                    {currentOrderData.payment!.totalAmount.toLocaleString()} 원
                  </div>
                </div>
              </div>
            </div>
            <div
              className='basic-btn TO-button-1 pointer'
              style={{ alignSelf: "flex-start" }}
              onClick={() => {
                resetCart();
                resetOrderState();
                turnOnTooltipView(true);
                setRobotView(true);
                navigate("/menu");
              }}
            >
              확인
            </div>
          </div>
        </div>
      )}
    </>
  );
}
export default PaymentSuccess;
